import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Ghost } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Values',
    href: '#values'
  }, {
    name: 'Games',
    href: '#games'
  }, {
    name: 'Services',
    href: '#services'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-abyss/90 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-119">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-120">
        <a href="#" className="flex items-center gap-3 group" data-id="element-121">
          <div className="relative" data-id="element-122">
            <Ghost className="w-8 h-8 text-mystic-500 transition-transform duration-500 group-hover:scale-110" data-id="element-123" />
            <div className="absolute inset-0 bg-mystic-500 blur-lg opacity-20 group-hover:opacity-40 transition-opacity" data-id="element-124" />
          </div>
          <span className="text-2xl font-serif font-bold text-white tracking-widest group-hover:text-glow transition-all" data-id="element-125">
            OMBRELUDIQUE
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-126">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-400 hover:text-mystic-400 transition-colors uppercase tracking-widest" data-id="element-127">
              {link.name}
            </a>)}
          <Button size="sm" variant="primary" data-id="element-128">
            Submit Game
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-129">
          {isMobileMenuOpen ? <X data-id="element-130" /> : <Menu data-id="element-131" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-132">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-shadow border-b border-white/5 overflow-hidden" data-id="element-133">
            <div className="px-6 py-8 flex flex-col gap-6" data-id="element-134">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-serif text-gray-300 hover:text-mystic-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-135">
                  {link.name}
                </a>)}
              <Button className="w-full" data-id="element-136">Submit Game</Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}